var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shadow-lg", staticStyle: { "background-color": "white" } },
    [
      _c("vue-cal", {
        staticStyle: { height: "700px" },
        attrs: {
          "disable-views": ["years", "year", "week", "day"],
          locale: "de",
          "events-on-month-view": "short",
          events: _vm.events
        },
        on: {
          ready: function($event) {
            return _vm.calendarReady($event)
          },
          "view-change": function($event) {
            return _vm.onViewChange($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }